export default function FilledPlugIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.33337 4L5.33337 1.01042C5.33337 0.74244 5.43873 0.485437 5.62627 0.295946C5.8138 0.106456 6.06816 0 6.33337 0C6.59859 0 6.85294 0.106456 7.04048 0.295946C7.22802 0.485437 7.33337 0.74244 7.33337 1.01042L7.33337 4H9.33337V1.01042C9.33337 0.74244 9.43873 0.485437 9.62627 0.295946C9.8138 0.106456 10.0682 0 10.3334 0C10.5986 0 10.8529 0.106456 11.0405 0.295946C11.228 0.485437 11.3334 0.74244 11.3334 1.01042V4H12.2048C12.5005 4.0018 12.7836 4.12261 12.9926 4.33625C13.2017 4.54989 13.3199 4.83913 13.3217 5.14125L13.3194 7.63375C13.353 8.09177 13.3991 9.50083 12.496 10.8544C12.0294 11.5387 11.4046 12.0947 10.677 12.4727C10.2262 12.7053 9.77237 12.8468 9.33337 12.9239V14.9896C9.33337 15.2576 9.22802 15.5146 9.04048 15.7041C8.85294 15.8935 8.59859 16 8.33337 16C8.06816 16 7.8138 15.8935 7.62627 15.7041C7.43873 15.5146 7.33337 15.2576 7.33337 14.9896V12.8923C6.63882 12.7596 6.13456 12.543 5.97657 12.4727C4.34523 11.6099 3.4674 10.1978 3.33337 8.30176V5.14125C3.33513 4.83913 3.45336 4.54989 3.66243 4.33625C3.8715 4.12261 4.15456 4.0018 4.45022 4H5.33337Z"
        fill="#183558"
      />
    </svg>
  );
}
